import type { ReactElement } from 'react';
import { Radio, RadioGroup } from 'react-aria-components';

export interface SegmentedOption {
  value: string;
  label: string;
}

export interface SegmentedControlProps {
  /** Accessible name of the group. */
  label: string;
  options: readonly SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  /** Layout utilities only. */
  className?: string;
}

export function SegmentedControl({
  label,
  options,
  value,
  onChange,
  className
}: SegmentedControlProps): ReactElement {
  return (
    <RadioGroup
      aria-label={label}
      orientation="horizontal"
      value={value}
      onChange={onChange}
      className={`inline-flex m-0 p-0 border-0 bg-transparent font-ui ${className ?? ''}`.trim()}
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          value={option.value}
          // One shared border between segments (-ml-px) and rounded outer ends; the selected
          // segment rises above its neighbours so its ink border is never half-covered.
          className="relative inline-flex items-center m-0 px-3 py-1 touch:min-h-[44px] -ml-px first:ml-0 first:rounded-l-control last:rounded-r-control border border-solid border-line-strong bg-surface text-ink text-sm font-ui cursor-pointer hover:bg-panel selected:z-10 selected:bg-ink selected:text-on-ink-strong selected:border-ink focus-visible:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
        >
          {option.label}
        </Radio>
      ))}
    </RadioGroup>
  );
}
